"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentClientFactory = void 0;
const Factory = require("factory.ts");
exports.currentClientFactory = Factory.Sync.makeFactory({
    id: 1,
    name: 'SE Resource Types',
    client_id: 'abcdef1234567890',
    ngin: true,
    access_all_orgs: true,
    inheritable_role_assignments: []
});
